import axios from "axios";

class Search_foretag {
  // 1. describe and create/initiate our object
  constructor() {
    console.log("search_foretag.js running here! constructor 002");
    this.addSearchHTML();
    this.resultsDiv = document.querySelector("#tableplaceholderforetag");
    this.openButton = document.querySelectorAll(".js-search-trigger");
    this.closeButton = document.querySelector(".search-overlay__close");
    this.searchOverlay = document.querySelector(".search-overlay");
    this.searchField = document.querySelector("#search-term2");
    this.isOverlayOpen = false;
    this.isSpinnerVisible = false;
    this.previousValue;
    this.typingTimer;
    this.events();
  }

  // 2. events
  events() {
    this.openButton.forEach((el) => {
      el.addEventListener("click", (e) => {
        e.preventDefault();
        this.openOverlay();
      });
    });

    this.closeButton.addEventListener("click", () => this.closeOverlay());
    document.addEventListener("keydown", (e) => this.keyPressDispatcher(e));
    this.searchField.addEventListener("keyup", () => this.typingLogic());
  }

  // 3. methods (function, action...)
  typingLogic() {
    if (this.searchField.value != this.previousValue) {
      clearTimeout(this.typingTimer);

      if (this.searchField.value) {
        if (!this.isSpinnerVisible) {
          this.resultsDiv.innerHTML =
            '<div style="width:100%;text-align:center;background-color:green"><div style="margin:auto;width:background-color:transparent" class="spinner-loader"></div></div>';
          this.isSpinnerVisible = true;
        }
        this.typingTimer = setTimeout(this.getResults.bind(this), 750);
      } else {
        this.resultsDiv.innerHTML = "";
        this.isSpinnerVisible = false;
      }
    }

    this.previousValue = this.searchField.value;
  }

  async getResults() {
    try {
      const response = await axios.get(
        rekforetagenData.root_url +
          "/wp-json/reksearchforetag/v1/search?term=" +
          this.searchField.value
      );
      const results = response.data;

      let doadresser = true;
      this.resultsDiv.innerHTML = `
      
            <!--<table width='100%' style="background-color:lightblue">
            <thead><th colspan="5">Antal aktuella rekryteringsföretag</th></thead>
            <tbody>-->

            <div>
	<div style="float:left;width:185px;background-color:transparent">&nbsp;</div>
	<div class="rek_c1" style="font-size:18px;font-weight:bold"><a class="foretag" href="https://rekryteringsforetagen.se/">Nya</a></div>
	<div class="rek_c3" style="font-size:18px;font-weight:bold"><a class="foretag" href="https://rekryteringsforetagen.se/?sort=7dagar">7 dagar</a></div>
	<div class="extrainfo01" style="font-size:18px;font-weight:bold;line-height: 1.4"><a class="foretag" href="https://rekryteringsforetagen.se/?sort=alla">Alla</a></div>
	<div class="extrainfo02" style="font-size:18px;font-weight:bold;line-height: 1.4;"><div><a class="foretag" href="https://rekryteringsforetagen.se/?sort=ftyp">Företagstyp</a></div>
	</div><div class="extrainfo03" style="font-size:18px;font-weight:bold;line-height: 1.4;"><div><a class="foretag" href="https://rekryteringsforetagen.se/?sort=grupp">Grupp</a></div>
	</div>
	<div style="clear:both"></div>
</div>
            ${
              results.foretag.length
                ? "<div style='background-color:transparent'>&nbsp;</div>"
                : `<div><p>Inga företag matchar sökningen. <a href="${rekforetagenData.root_url}/">Visa alla företag</a></p></div>`
            }
              ${results.foretag
                .map(
                  (item, index) => `<div>
                                      <div class="rek_c0"><span class="ispan">
                        ${index + 1}) </span><a class="foretag" href="${
                          item.permalink
                        }">${item.title} </a></div>
                        <div class="rek_c1"><a class="foretag" href="${
                          item.permalink
                        }">${item.nyajobb}</a></div>
                        <div class="rek_c3"><a class="foretag" href="${
                          item.permalink
                        }">${item.sjudagar}</a></div>
                        <div class="rek_c3"><a class="foretag" href="${
                          item.permalink
                        }">${item.alladagar}</a></div>
                        <div class="extrainfo02">${this.print_ftyp(
                          item.ftyp
                        )}</div>
                        <div class="extrainfo03">${item.grupp}</div>
                        <div style="clear:both"></div>${this.print_adresser(
                          index,
                          doadresser,
                          item.adresser,
                          item.thumbnailsrc
                        )}
                      </div>`
                )
                .join("")}
        
      `;
      this.isSpinnerVisible = false;
      console.log(
        "Search_foretag.js running here! getResults 002 ö this.isSpinnerVisible = false; "
      );
    } catch (e) {
      console.log(
        "Search_foretag.js running here! getResults 002 öö catch (e) " + e
      );
      console.log(e);
    }
  }

  print_ftyp(ftyp) {
    if (ftyp.trim() == "") {
      return "-";
    } else {
      return ftyp;
    }
  }
  print_adresser(index, doadresser, adresser, thumbnailsrc) {
    // return "";
    if (doadresser && index < 8) {
      adresser = adresser.replaceAll("\n", "");
      adresser = adresser.replaceAll("\t", "");
      adresser = adresser.replaceAll("\r", "");
      let adresser_json = JSON.parse(adresser);
      return `<div style="float:left;text-align:left;margin-left:20px;width:60%"><div class="foretag">${adresser_json[0].street}</div><div class="foretag">${adresser_json[0].zipcode}&nbsp;${adresser_json[0].city}</div><div class="foretag">${adresser_json[0].phone}</div></div><div style="width:35%;background-color:transparent;float:left;padding-left:10px;text-align:left"><img width="80" src="${thumbnailsrc}"/></div><div style="clear:both"></div><div style="width:100%;background-color:white;line-height:0.1;margin-bottom:10px">&nbsp;</div>`;
    } else {
      return "";
    }
  }
  keyPressDispatcher(e) {
    console.log("Search_foretag.js running here! keyPressDispatcher 003");
    if (
      e.keyCode == 83 &&
      !this.isOverlayOpen &&
      document.activeElement.tagName != "INPUT" &&
      document.activeElement.tagName != "TEXTAREA"
    ) {
      this.openOverlay();
    }

    if (e.keyCode == 27 && this.isOverlayOpen) {
      this.closeOverlay();
    }
  }

  openOverlay() {
    console.log("Search_foretag.js running here! openOverlay 004");
    this.searchOverlay.classList.add("search-overlay--active");
    document.body.classList.add("body-no-scroll");
    this.searchField.value = "";
    setTimeout(() => this.searchField.focus(), 301);
    console.log("our open method just ran!");
    this.isOverlayOpen = true;
    return false;
  }

  closeOverlay() {
    console.log("Search2.js running here! closeOverlay 005");
    this.searchOverlay.classList.remove("search-overlay--active");
    document.body.classList.remove("body-no-scroll");
    console.log("our close method just ran!");
    this.isOverlayOpen = false;
  }

  getImgFromShort(short) {
    var dir = "https://rekryteringsforetagen.se/wp-content/uploads";
    var gender_arr = ["imagesrc_m", "imagesrc_k"];
    let imagesrc =
      "https://rekryteringsforetagen.se/wp-content/uploads/2025/05/factory.webp";

    if (short == "a_hub") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/08/a_hub-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/08/a_hub-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "adadigital") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/08/adadigital-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/08/adadigital-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "adecco") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/05/adecco-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/05/adecco-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }

    if (short == "amendo") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/07/amendo-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/07/amendo-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "amendotech") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/07/amendotech-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/07/amendotech-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "ants") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/08/ants-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/08/ants-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "arena") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/05/arena-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/05/arena-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "asta") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/07/asta-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/07/asta-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "aw") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/08/aw-person-k2-300x300.webp";
      var imagesrc_m = dir + "/2025/08/aw-person-m2-300x300.webp";
      imagesrc = eval(gender_arr[index]);
      //      imagesrc =
      //        "https://rekryteringsforetagen.se/wp-content/uploads/2025/05/aw-person-300x300.webp";
    }
    if (short == "axo") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/07/axo-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/07/axo-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "bemannia") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/07/bemannia-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/07/bemannia-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "bemannica") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/06/bemannica-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/06/bemannica-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "bohmans") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/07/bohmans-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/07/bohmans-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "bonliva") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/12/bonliva-person-k3-300x300.webp";
      var imagesrc_m = dir + "/2025/12/bonliva-person-m3-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "bravura") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/08/bravura2-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/08/bravura2-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "centric") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/07/centric-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/07/centric-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "clockwork") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/05/clockwork-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/05/clockwork-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "closers") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/08/closers-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/08/closers-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "effektiv") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/06/effektiv-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/06/effektiv-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "eqonomy") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/07/eqonomy-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/07/eqonomy-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "financerecruitment") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k =
        dir + "/2025/07/financerecruitment-person-k-300x300.webp";
      var imagesrc_m =
        dir + "/2025/07/financerecruitment-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "flipr") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/08/flipr-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/08/flipr-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "framtiden") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/05/framtiden-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/05/framtiden-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }

    if (short == "gazella") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/08/gazella-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/08/gazella-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "gigstep") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/06/gigstep-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/06/gigstep-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "headagent") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/08/headagent-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/08/headagent-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "humancapital") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/11/humancapital-person-k2-300x300.webp";
      var imagesrc_m = dir + "/2025/11/humancapital-person-m2-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "jerrie") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/08/jerrie-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/08/jerrie-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "jobandtalent") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/05/jobandtalent-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/05/jobandtalent-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "jobway") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/08/jobway-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/08/jobway-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    // https://rekryteringsforetagen.se/wp-content/uploads/2025/05/salesonly-person.webp
    if (short == "ins") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/06/ins-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/06/ins-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "inhouse") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/07/inhouse-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/07/inhouse-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "intensogruppen") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/07/intensogruppen-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/07/intensogruppen-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "intensoteknik") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/07/intensoteknik-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/07/intensoteknik-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "invici") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/08/invici-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/08/invici-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "kfx") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/11/kfx-person-k2-300x300.webp";
      var imagesrc_m = dir + "/2025/11/kfx-person-m2-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "kimm") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/07/kimm-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/07/kimm-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "knack") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/08/knack-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/08/knack-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "kraftsam") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/06/kraftsam-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/06/kraftsam-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "lagotto") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/07/lagotto-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/07/lagotto-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "lernia") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/06/lernia-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/06/lernia-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "level") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/07/level-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/07/level-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "levelexecutive") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/07/levelexecutive-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/07/levelexecutive-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "maquire") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/08/maquire-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/08/maquire-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "max") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/08/max-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/08/max-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "montico") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/08/montico-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/08/montico-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "madeforsales") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/08/madeforsales-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/08/madeforsales-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "nexer") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/07/nexer-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/07/nexer-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "nl") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/08/nl-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/08/nl-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "novare") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/05/novare-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/05/novare-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "oddwork") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/08/oddwork-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/08/oddwork-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "one") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/06/one-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/06/one-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "pn") {
      imagesrc =
        "https://rekryteringsforetagen.se/wp-content/uploads/2025/05/pn-person3-300x300.webp";
    }
    if (short == "poolia") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/05/poolia-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/05/poolia-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "qrios") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/05/qrios-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/05/qrios-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "qsearch") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/11/qsearch-person-k3-300x300.webp";
      var imagesrc_m = dir + "/2025/11/qsearch-person-m3-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "quadruped") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/08/quadruped-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/08/quadruped-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }

    if (short == "recruitive") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/08/recruitive-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/08/recruitive-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "rejlers") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/07/rejlers-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/07/rejlers-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "roi") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/07/roi-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/07/roi-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "rs") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/05/rs-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/05/rs-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "rubino") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/08/rubino-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/08/rubino-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "salesgroup") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/11/salesgroup-person-k2-300x300.webp";
      var imagesrc_m = dir + "/2025/11/salesgroup-person-m2-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "salesonly") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/11/salesonly-person-k2-300x300.webp";
      var imagesrc_m = dir + "/2025/11/salesonly-person-m2-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "saljpoolen") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/07/saljpoolen-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/07/saljpoolen-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    // https://rekryteringsforetagen.se/wp-content/uploads/2025/08/skillexcutive-person-k-2.webp
    if (short == "skillexecutive") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/08/skillexcutive-person-k-2-300x300.webp";
      var imagesrc_m = dir + "/2025/08/skillexecutive-person-m-2-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "soprasteria") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/07/soprasteria-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/07/soprasteria-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "source") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/07/source-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/07/source-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "tacting") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/08/tacting-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/08/tacting-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "tff") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/06/tff-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/06/tff-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "thepace") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/08/thepace-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/08/thepace-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "theplace") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/08/theplace-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/08/theplace-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "tng") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/06/tng-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/06/tng-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "experis") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/06/experis-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/06/experis-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "jw") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/05/jw-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/05/jw-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "jurek") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/06/jurek-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/06/jurek-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "jobsolution") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/06/jobsolution-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/06/jobsolution-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "perido") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/06/perido-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/06/perido-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "madeforsales") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/08/madeforsales-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/08/madeforsales-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]); // https://rekryteringsforetagen.se/wp-content/uploads/2025/07/needo-person-k.webp
    }
    if (short == "meritmind") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/08/meritmind-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/08/meritmind-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "mp") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/08/mp-person-k-2-300x300.webp";
      var imagesrc_m = dir + "/2025/08/mp-person-m-2-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "multimind") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/07/multimind-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/07/multimind-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]); // https://rekryteringsforetagen.se/wp-content/uploads/2025/07/needo-person-k.webp
    }

    if (short == "nearyou") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/06/nearyou-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/06/nearyou-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "needo") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/07/needo-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/07/needo-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]); // https://rekryteringsforetagen.se/wp-content/uploads/2025/07/needo-person-k.webp
    }
    if (short == "skill") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/05/skill-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/05/skill-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "sjr") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/06/sjr-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/06/sjr-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }

    if (short == "sc") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/06/sc-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/06/sc-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "thalamus") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/08/thalamus-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/08/thalamus-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }

    if (short == "uniflex") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/06/uniflex-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/06/uniflex-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "vindex") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/11/vindex-person-k2-300x300.webp";
      var imagesrc_m = dir + "/2025/11/vindex-person-m2-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "wikan") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/05/wikan-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/05/wikan-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "wise") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/06/wise-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/06/wise-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "wiseconsulting") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/08/wiseconsulting-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/08/wiseconsulting-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    if (short == "wiseit") {
      let index = Math.floor(Math.random() * 2);
      var imagesrc_k = dir + "/2025/05/wiseit-person-k-300x300.webp";
      var imagesrc_m = dir + "/2025/05/wiseit-person-m-300x300.webp";
      imagesrc = eval(gender_arr[index]);
    }
    return imagesrc;
  }
  addSearchHTML() {
    console.log("Search_foretag.js running here! addSearchHTML 006");
    document.body.insertAdjacentHTML(
      "beforeend",
      `
      <div class="search-overlay">
        <div class="search-overlay__top">
          <div class="container">
            <i class="fa fa-search search-overlay__icon" aria-hidden="true"></i>
            <input type="text" class="search-term swapcolor"  placeholder="filtrera här" id="search-term">
            <i class="fa fa-window-close search-overlay__close" aria-hidden="true"></i>
          </div>
        </div>
        
        <div class="container">
          <div id="search-overlay__results"></div>
        </div>

      </div>
    `
    );
  }
}

export default Search_foretag;
